export default __webpack_public_path__ + "static/media/Work only with the best.357f9345.png";